import { Card, CardContent } from '@mui/material';
import { OneMedia } from '@prismamedia/one-components';
import { EditorState } from 'draft-js';
import React, { FC, memo } from 'react';
import { BlockItemType } from '../../utils';
import { BlockItemContent } from './Content';
import { BlockItemFooter } from './Footer';
import { BlockItemHeader } from './Header';
import { BlockItemMedia } from './Media';
import { useStyles } from './styles';

export enum BlockItemFormat {
  AUTO_PROMO,
  CONDENSED,
  EXPANDED,
}
interface BlockItemProps {
  item: BlockItemType;
  format: BlockItemFormat;
  onDeleteBlock?: () => void;
  onSetLeadIn?: () => void;
  onEditField?: (field: string, value: string | OneMedia | EditorState) => void;
}

export const BlockItemDesktop: FC<BlockItemProps> = memo(
  ({
    format: blockItemFormat,
    item,
    onDeleteBlock,
    onSetLeadIn,
    onEditField,
  }) => {
    const {
      articleAuthors,
      articleCategories,
      articleChannels,
      articleEvents,
      articleQualifiers,
      campaigns,
      blockType,
      brandKey,
      content,
      format,
      linkLabel,
      media,
      body,
      mediaForDisplay,
      publishedAt,
      pushCount,
      status,
      surTitle,
      title,
      url,
      urlInError,
      urlInErrorMessage,
      medias,
    } = item;

    const classes = useStyles({ blockItemFormat });

    return (
      <div className={classes.wrapper}>
        <Card className={classes.innerWrapper} variant="outlined">
          <BlockItemMedia
            articleProps={{
              brandKey,
              media,
              mediaForDisplay,
              body,
              blockType,
            }}
            format={blockItemFormat}
            onEditField={onEditField}
          />

          <CardContent classes={{ root: classes.content }}>
            <BlockItemHeader
              articleProps={{
                author: articleAuthors?.[0]?.author.name,
                campaigns,
                format,
                publishedAt,
                status,
                pushCount,
              }}
              format={blockItemFormat}
            />
            <BlockItemContent
              articleProps={{
                blockType,
                content,
                linkLabel,
                surTitle,
                title,
                url,
                urlInError,
                urlInErrorMessage,
                articleQualifiers,
              }}
              format={blockItemFormat}
              onDeleteBlock={onDeleteBlock}
              onEditField={onEditField}
              onSetLeadIn={onSetLeadIn}
            />

            <BlockItemFooter
              articleProps={{
                articleCategories,
                articleChannels,
                articleEvents,
                format,
                pushCount,
                medias,
              }}
              format={blockItemFormat}
            />
          </CardContent>
        </Card>
      </div>
    );
  },
);
